import { useState, useEffect } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import type { Group } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/insight-roles.tsx';

export const getGroupValues = (attribute?: InsightObjectAttribute): Group[] => {
	if (attribute && attribute.type === 'group') {
		return attribute.groupTypeValues.map(({ group }) => ({ name: group.name }));
	}
	return [];
};

export const getGroupValuesFromCmdbObjectAttribute = (attribute?: CmdbObjectAttribute): Group[] => {
	if (attribute && attribute.type === AttributeTypeMap.Group) {
		return attribute.objectAttributeValues.map(({ group }) => ({ name: group.name }));
	}
	return [];
};

export const useGroupValue = (attribute?: InsightObjectAttribute) => {
	const groups = getGroupValues(attribute);
	const [value, setValue] = useState<Group[]>(groups);

	useEffect(() => {
		setValue(() => getGroupValues(attribute));
	}, [attribute]);

	return [value, setValue] as const;
};
